import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Collapse, IconButton } from '@mui/material';
import { grey } from '@mui/material/colors';
import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router';
const expandedCardKey = 'expandedCard';
export const ExpandableCard = ({ id, children, cardContent, cardAriaLabel, collapseAriaLabel, expandAriaLabel, onExpand, onCollapse, }) => {
    var _a;
    const [searchParams, setSearchParams] = useSearchParams();
    const isExpanded = (_a = searchParams.get(expandedCardKey)) === null || _a === void 0 ? void 0 : _a.split(',').includes(id);
    useEffect(() => {
        if (isExpanded && onExpand) {
            onExpand();
        }
        if (!isExpanded && onCollapse) {
            onCollapse();
        }
    }, [isExpanded, onExpand, onCollapse]);
    const toggleCard = () => {
        setSearchParams((prevValues) => {
            const expandedValues = prevValues.get(expandedCardKey);
            if (!expandedValues) {
                prevValues.set(expandedCardKey, id);
                return prevValues;
            }
            if (expandedValues.includes(id)) {
                const newValue = expandedValues
                    .split(',')
                    .filter((prevId) => prevId !== id)
                    .join(',');
                prevValues.set(expandedCardKey, newValue);
                return prevValues;
            }
            const newValue = expandedValues.split(',');
            newValue.push(id);
            prevValues.set(expandedCardKey, newValue.join(','));
            return prevValues;
        }, { replace: true });
    };
    return (React.createElement(Box, { sx: {
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column',
        }, "data-test": 'expandable-card' },
        React.createElement(Box, { sx: {
                display: 'flex',
                flexGrow: 1,
                position: 'relative',
                p: 2,
                '&:hover': { backgroundColor: grey[200], cursor: 'pointer' },
            }, role: 'region', "aria-label": cardAriaLabel, "aria-expanded": isExpanded, "aria-controls": `collapse-${id}`, onClick: () => toggleCard() },
            React.createElement(IconButton, { "aria-label": isExpanded ? collapseAriaLabel : expandAriaLabel, sx: {
                    position: { xs: 'absolute', lg: 'relative' },
                    transform: isExpanded ? 'rotate(180deg)' : undefined,
                    mr: 2,
                    my: { sm: 1, lg: 2 },
                } },
                React.createElement(ExpandMoreIcon, { fontSize: 'medium', color: 'primary', "data-test": isExpanded ? 'collapse-icon' : 'expand-icon', "aria-hidden": true })),
            cardContent),
        children && (React.createElement(Collapse, { in: isExpanded, id: `collapse-${id}` }, children))));
};
